export * from "./skin-list";
export * from "./template-type";
export * from "./urls";
export * from "./skins";
export * from "./theme";
export * from "./country";
export * from "./addons.constants";

export const HEADER_CATEGORIES_SHOW_PARAM = "hCat";
import { ASSETS_URL } from "./urls";
export const WEB_ASSETS = `${ASSETS_URL}/prod/assets/web`;
export const OPEN_APP_STORE_ANDROID =
  "https://link.domun.co/sDH5/webandroid";
export const OPEN_APP_STORE_IOS = "https://link.domun.co/sDH5/webios";
export const OPEN_APP_STORE_ANDROID_GOOGLE =
  "https://link.domun.co/sDH5/4ssvh3fk";
export const OPEN_APP_STORE_IOS_GOOGLE =
  "https://link.domun.co/sDH5/tzl687sd";
